// 一些工具函数

// 判断数据类型
export function typeOf(value) {
  return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
}

// 处理时间函数(没啥用)--略

// 将json格式转化为formdata格式
export function getFormData(obj) {
  let formData = new FormData();
  Object.keys(obj).forEach((item) => {
    formData.append(item, obj[item]);
  });
  return formData;
}

// 把文件按照二进制进行读取export
export function readFile(file) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (ev) => {
      resolve(ev.target.result);
    };
  });
}
